import * as React from 'react'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import store from '../../store'
import ElementsSelector from './elements_selector'
import { initElements } from '../../actions/campaigns/elements_selector_actions'
import { selectByTags } from '../../actions/campaigns/common_actions'

import ByTagsSelector from './by_tags_selector'

interface ElementsSelectorAppProps {
  id: string | number
  step: string | number
  is_ready: boolean
  elements: any[]
  tags: any[]
  element_form_data: any
  show_additions: boolean
  show_images: boolean
  selectedTags: any[]
  visible_columns: string[]
}

const ElementsSelectorApp: React.FC<ElementsSelectorAppProps> = ({
  id,
  step,
  is_ready,
  elements,
  tags,
  element_form_data,
  show_additions,
  show_images,
  selectedTags,
  visible_columns,
}) => {
  useEffect(() => {
    store.dispatch(
      initElements({
        id,
        step,
        isReady: is_ready,
        elements,
        tags,
        elementFormData: element_form_data,
        showAdditions: show_additions,
        showImages: show_images,
        visibleColumns: visible_columns,
      })
    )

    if (selectedTags.length) {
      store.dispatch(selectByTags(selectedTags, 'elements', true))
    }
  }, [])

  return (
    <Provider store={store}>
      <ElementsSelector ByTagsSelector={ByTagsSelector} />
    </Provider>
  )
}

export default ElementsSelectorApp
